import React, { createContext, useContext, useMemo, useState } from "react";

import { noop } from "lodash";
import { useLocation } from "react-router-dom";
import membersService from "@services/members.service";
import { useMemberListStore } from "@stores/useMemberListStore";

export type UseMembersProps = {};

export type UseMembers = (props: UseMembersProps) => {
  sidebarExpand: boolean;
  handleSidebar: (val: boolean) => void;
  membersOfCurrentPage: any[];
};

export const useMembers: UseMembers = function (props) {
  const membersOfMemberListPage = useMemberListStore((state) => state.data);
  const currentMemberOfMemberDetailPage = membersService?.getCurrentMember;
  const [sidebarExpand, setSideBarExpand] = useState<any>(false);
  const location = useLocation();

  function handleSidebar(value: boolean) {
    setSideBarExpand(value);
  }

  const membersOfCurrentPage = useMemo(() => {
    if (location.pathname === "/member-detail") {
      return [currentMemberOfMemberDetailPage];
    } else if (location.pathname === "/members") {
      return membersOfMemberListPage;
    } else {
      return [];
    }
  }, [membersOfMemberListPage, currentMemberOfMemberDetailPage, location.pathname]);

  return { sidebarExpand, handleSidebar, membersOfCurrentPage};
};

export const MembersContext = createContext<ReturnType<UseMembers>>({
  sidebarExpand: false,
  handleSidebar: noop,
  membersOfCurrentPage: [],
});

export const MembersProvider: React.FC<UseMembersProps> = function ({ children, ...props }) {
  const membersValue = useMembers(props);

  return <MembersContext.Provider value={membersValue}>{children}</MembersContext.Provider>;
};

export const useMembersContext = () => useContext(MembersContext);
